import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLElement>

const Section = forwardRef<HTMLElement, SectionProps>(
  ({ className, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(
          'relative h-auto w-full lg:h-full lg:w-auto lg:shrink-0 lg:grow-0',
          className
        )}
        {...props}
      ></section>
    )
  }
)

export default Section
